import { render, staticRenderFns } from "./PaymentSpecialFranchise.vue?vue&type=template&id=6643abc3&"
import script from "./PaymentSpecialFranchise.vue?vue&type=script&lang=js&"
export * from "./PaymentSpecialFranchise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports